import DEFAULT_VALUES_LAYER from '../default'

const { page: DEFAULT_PAGE_LAYER, ...rest } = DEFAULT_VALUES_LAYER

export default {
  adDeactivatedSold: {
    ...rest,
    page: {
      ...DEFAULT_PAGE_LAYER,
      pageType: 'anuncio-desativado',
      pageName: '/webmotors/comprar/detalhe/anuncio-desativado',
      pageNameTier2: 'detalhe',
      pageNameTier3: 'anuncio-desativado',
    },
  },
}
